
define('text!modules/creatives/display/templates/list.html',[],function () { return '<div class="list-filters w-Filters no-entities clearfix"></div>\n<div class="list-body w-CreativesDisplay display">\n\t<div class="w-grid"></div>\n</div>\n';});

